import {EmptyFeatureResult, getState, signalStoreFeature, SignalStoreFeature, SignalStoreFeatureResult, withMethods} from '@ngrx/signals';

type WithGetStateOutput<T> = EmptyFeatureResult & {
	methods: {
		getState: () => T;
	};
};

export function withGetState<T = any>(): SignalStoreFeature<SignalStoreFeatureResult, WithGetStateOutput<T>> {
	return signalStoreFeature(
		withMethods(store => ({
			getState: function () {
				return getState(store) as T;
			},
		})),
	);
}
